import React from 'react'
import { connect } from 'react-redux'
import { doGetArchivesTemplet, doSaveArchivesTemplet, doDeleteArchivesTemplet } from '../../reducers/actions'

class ArchivesTemplet extends React.Component {
  state = {}
  componentDidMount = () => {
    const { onClose, dispatch, id } = this.props
    dispatch(doGetArchivesTemplet({
      id,
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ id, initValues基本信息, changedValues基本信息: {} })
        }
      }
    }))
  }

  handlerConfirm = () => {
    const { initValues基本信息, changedValues基本信息, id } = this.state
    const { onSave, onClose, dispatch } = this.props
    dispatch(doSaveArchivesTemplet({
      id,
      changedValues基本信息,
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else {
          Ext.toast('保存成功')
          onSave && onSave()
          onClose && onClose()
        }
      }
    }))
  }

  handlerDelete = () => {
    const { id } = this.state
    const { onSave, onClose, dispatch } = this.props

    Tyan.pubForm.showConfirm('确定要删除？', () =>
      dispatch(doDeleteArchivesTemplet({
        id,
        onEnd: ({ errorMessage }) => {
          if (errorMessage) {
            Tyan.pubForm.showError(errorMessage)
          }
          else {
            Ext.toast('删除成功')
            onSave && onSave()
            onClose && onClose()
          }
        }
      })))
  }

  handlerClose = () => {
    const { onClose } = this.props
    if (!this.bChanged()) {
      onClose && onClose()
      return
    }
    Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
  }


  canSave = () => {
    const { initValues基本信息, changedValues基本信息 } = this.state
    const values = { ...initValues基本信息, ...changedValues基本信息 }
    return this.bChanged() && values.模板名称 && values.自动编号
  }

  bChanged = () => {
    const { changedValues基本信息 } = this.state
    return Object.keys(changedValues基本信息).length > 0
  }


  fieldset基本信息 = () => {
    const { initValues基本信息, changedValues基本信息 } = this.state
    return [
      { _text: '模板名称', name: '模板名称', minWidth: '1000px', required: true, },
      { _select: '自动编号', name: '自动编号', required: true, options: initValues基本信息.items自动编号 },
      { _text: '说明', name: '说明', minWidth: '1000px', },
      { _text: '格式内容', name: '格式内容', minWidth: '1000px', maxRows: 30 },
      { _text: '公文流程', name: '公文流程', minWidth: '1000px', maxRows: 30 },
    ]
  }

  render() {
    const { showMessage: Message, showBody: Body } = this.props
    const { initValues基本信息, changedValues基本信息 } = this.state
    if (!initValues基本信息) return <Message text={'请稍等 ...'} />

    return <Body data={this} maxWidth="1100"
      controls={
        [
          { _button: '保存', icon: 'save', handler: this.handlerConfirm, disabled: !this.canSave() },
          { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 },
          { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
        ]}
      fieldsets={
        [
          { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
        ]}
    />
  }
}

export default connect()(ArchivesTemplet)